<template>
  <svg
    class="vue-icon"
    xmlns="http://www.w3.org/2000/svg"
    width="42"
    height="29"
    viewBox="0 0 42 29"
  >
    <g id="icon_cheque" data-name="icon/cheque" transform="translate(-147 -20)">
      <path
        id="Tracé_3"
        data-name="Tracé 3"
        d="M574.154,374.455H586.71a2.157,2.157,0,0,0,2.154-2.154v-.146A2.157,2.157,0,0,0,586.71,370H574.154A2.157,2.157,0,0,0,572,372.154v.146A2.157,2.157,0,0,0,574.154,374.455Zm-1.04-2.3a1.042,1.042,0,0,1,1.04-1.041H586.71a1.042,1.042,0,0,1,1.04,1.041v.146a1.042,1.042,0,0,1-1.04,1.041H574.154a1.042,1.042,0,0,1-1.04-1.041Z"
        transform="translate(-402.956 -344.613)"
        fill="#0d2864"
      />
      <path
        id="Tracé_4"
        data-name="Tracé 4"
        d="M510.557,413.114h11.859a.557.557,0,0,0,0-1.114H510.557a.557.557,0,0,0,0,1.114Z"
        transform="translate(-359.815 -386.294)"
        fill="#0d2864"
      />
      <path
        id="Tracé_14"
        data-name="Tracé 14"
        d="M510.557,413.114h33.972a.557.557,0,0,0,0-1.114H510.557a.557.557,0,0,0,0,1.114Z"
        transform="translate(-359.815 -379.614)"
        fill="#0d2864"
      />
      <path
        id="Tracé_15"
        data-name="Tracé 15"
        d="M510.557,413.114h33.972a.557.557,0,0,0,0-1.114H510.557a.557.557,0,0,0,0,1.114Z"
        transform="translate(-359.815 -377.069)"
        fill="#0d2864"
      />
      <path
        id="Tracé_13"
        data-name="Tracé 13"
        d="M510.557,413.114h11.859a.557.557,0,0,0,0-1.114H510.557a.557.557,0,0,0,0,1.114Z"
        transform="translate(-359.815 -383.909)"
        fill="#0d2864"
      />
      <path
        id="Tracé_6"
        data-name="Tracé 6"
        d="M451.029,445.068q.195-.169.376-.331a2.1,2.1,0,0,0,.509.4c1.4.785,3.279-.417,3.489-.557a5.765,5.765,0,0,0,1-.872l0,.024c.077.462.184,1.095.776,1.279.648.2,1.112-.357,1.485-.806a2.728,2.728,0,0,1,.58-.583,2.816,2.816,0,0,1,.418.729c.252.544.564,1.221,1.248,1.221h.008c.711-.006,1.011-.712,1.276-1.335a3.427,3.427,0,0,1,.41-.787c.1.053.423.287.96,1.267a.621.621,0,0,0,1.09-.6c-.529-.967-1.264-2.058-2.234-1.914-.761.113-1.1.907-1.369,1.545-.042.1-.092.217-.143.327-.042-.085-.083-.174-.117-.248-.281-.607-.629-1.363-1.406-1.449-.748-.083-1.264.534-1.677,1.031l-.083.1c-.079-.468-.191-1.1-.787-1.284-.573-.179-.984.251-1.312.6a4.674,4.674,0,0,1-.814.723c-.368.245-1.561.863-2.192.508a.85.85,0,0,1-.207-.168c1.6-1.561,2.091-2.56,1.694-3.309a1.355,1.355,0,0,0-.892-.643,2.057,2.057,0,0,0-1.6.238,2.614,2.614,0,0,0-.935,2.336,4.162,4.162,0,0,0,.194,1.116c-.174.158-.363.326-.567.5a.621.621,0,1,0,.815.938Zm1.177-3.856a.736.736,0,0,1,.391-.1.782.782,0,0,1,.293.049c-.03.14-.2.545-1.052,1.441,0-.046-.007-.093-.008-.14A1.521,1.521,0,0,1,452.205,441.212Z"
        transform="translate(-278.826 -401.339)"
        fill="#0d2864"
      />
    </g>
  </svg>
</template>

<script>
export default {
  name: 'IconLogoBankCheque',
};
</script>
